export default {
  LIST_FETCHED: 'SCHEDULES_FETCHED',
  LIST_LOAD: 'SCHEDULE_LOAD',
  TEMPLATES_FETCHED: 'SCHEDULE_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'SCHEDULE_TEMPLATES_LOAD',
  ITEM_DETAIL: 'SCHEDULE_DETAIL',
  BUTTON_LOAD: 'SCHEDULE_BUTTON_LOAD',
};
